import React from "react";
import { activateDocument, deactivateDocument } from "../../librairies/Firestore";
import { isAdmin, useUser } from "../../contexts/UserContext";

const ToggleActivationLink = ({ collection, item, available=false }) => {

  const user = useUser();

  const handleToggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      if (item.active) {
        await deactivateDocument(collection, item.id);
        console.log(`Désactivé : ${item.id}`);
      } else {
        await activateDocument(collection, item.id);
        console.log(`Activé : ${item.id}`);
      }

    } catch (error) {
      console.error("Erreur lors du changement d'état :", error);
    }
  };

  return (
    (isAdmin(user.user) || available) &&
      <a
        href="#"
        onClick={handleToggle}
        className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
      >
        {item.active ? "Désactiver" : "Activer"}
      </a>
  );
};

export default ToggleActivationLink;